<template>
    <HeaderComponent/>
    <div :class="`main_content ${className || ''}`">
        <slot></slot>
    </div>
    <FooterComponent />
</template>
<script>
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from './HeaderComponent.vue';

export default {
    data() {
        return {
            siblings: {
                payment: [
                    {
                        title: '온라인',
                        link: '/business/online',
                    },
                    {
                        title: '오프라인',
                        link: '/business/offline',
                    },
                ],
                pos_system: [
                    { link: '/pos_system/main', title: '메인 솔루션' },
                    { link: '/pos_system/additional', title: '부가 솔루션' },
                    { link: '/pos_system/smartASP', title: 'Smart ASP' },
                ],
                other_service: [
                    {
                        title: '포인트',
                        link: '/business/other_service/point',
                    },
                    {
                        title: '디지털상품권',
                        link: '/business/other_service/digital_gift_certificate',
                    },
                    {
                        title: '멤버십',
                        link: '/business/other_service/membership',
                    },
                    {
                        title: '매출관리',
                        link: '/business/other_service/sales_management',
                    },
                    {
                        title: '이지톡페이',
                        link: '/business/other_service/easy_talk_pay',
                    },
                    {
                        title: '핫플레이스',
                        link: '/business/other_service/hot_place',
                    },
                    // {
                    //     title: '인터넷PC현금영수증',
                    //     link: '/business/other_service',
                    // },
                ],
            },
        };
    },
    mounted() {
        window.scrollTo(0, 0);
        document.title = this.$route.meta.name || `한국정보통신(주)`;
    },
    props: {
        src: {},
        sitemap: {},
        className: {},
        parent: {},
    },
    components: {
        HeaderComponent,
        FooterComponent,
    },
};
</script>
<style lang="scss" scoped>
.subpage_content {
    padding-bottom: 160px;
}
</style>
